import { SingleClaimContractChangesComments } from 'components/SingleClaimContractChangesComments/SingleClaimContractChangesComments';
import { SingleClaimMatches } from './sections/SingleClaimMatches';
import { SingleClaimOverview } from './sections/SingleClaimOverview/SingleClaimOverview';
import { SingleClaimSubheaderType } from './types';

import { ClaimEditValues } from 'api/endpoints';
import { SectionType } from 'pages/ClaimsContractsToolPage/types';
import { SingleClaimDocuments } from './sections/SingleClaimDocuments';
import { RelatedClaimsData } from './sections/SingleClaimOverview/util/getRelatedClaims';
import { SingleClaimRelatedClaims } from './sections/SingleClaimRelatedClaims/SingleClaimRelatedClaims';

export interface SingleClaimSectionsProps {
  tab: SingleClaimSubheaderType;
  claim: ClaimEditValues;
  relatedClaimsData: RelatedClaimsData;
}

export const SingleClaimSections = ({
  tab,
  claim,
  relatedClaimsData,
}: SingleClaimSectionsProps) => {
  switch (tab) {
    case SingleClaimSubheaderType.Overview:
      return <SingleClaimOverview />;
    case SingleClaimSubheaderType.Matches:
      return <SingleClaimMatches />;
    case SingleClaimSubheaderType.ChangesAndComments:
      return (
        <SingleClaimContractChangesComments
          claimId={claim.id}
          contractId={0}
          section={SectionType.Claims}
        />
      );
    case SingleClaimSubheaderType.Documents:
      return <SingleClaimDocuments />;
    case SingleClaimSubheaderType.RelatedClaims:
      return <SingleClaimRelatedClaims relatedClaimsData={relatedClaimsData} />;
    default:
      return null;
  }
};
